<template>
  <div :class="$style.feature">
    <BaseIcon
      name="check"
      color="success"
      size="l"
    />
    <BaseText>
      <slot />
    </BaseText>
  </div>
</template>

<style
  lang="scss"
  module
>
.feature {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.5;
  }
}
</style>
